import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "partners",
  class: "py-5 light-section"
}
const _hoisted_2 = { class: "container text-center" }
const _hoisted_3 = { class: "row justify-content-center partner-container" }
const _hoisted_4 = { class: "card-body d-flex flex-column" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "partner-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-5" }, "Unsere Partner", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["card col-md-3 slide-in-card", { 'slide-in-card-active': _ctx.partnerCardsVisible }]),
            key: partner.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: partner.logo,
                alt: `Logo von ${partner.name}`,
                class: "img-fluid partner-logo"
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, _toDisplayString(partner.name), 1)
            ])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}